// theme-init.js
// Global section initialization system for custom JS.
// Safe to load on every page. Individual initializers guard their own dependencies.

(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  window.SectionInitializers = window.SectionInitializers || {};

  function getJQuery() {
    return window.jQuery || window.$ || null;
  }

  function getSectionNodes(root) {
    var context = root || document;
    var nodes = [];

    if (context.nodeType === 1 && context.hasAttribute && context.hasAttribute('data-section-type')) {
      nodes.push(context);
    }

    var descendants = context.querySelectorAll ? context.querySelectorAll('[data-section-type]') : [];
    for (var i = 0; i < descendants.length; i++) {
      nodes.push(descendants[i]);
    }

    return nodes;
  }

  function getHeroSliderNodes(root) {
    var context = root || document;
    var nodes = [];

    if (context.nodeType === 1 && context.classList && context.classList.contains('hero-banner-slider')) {
      nodes.push(context);
    }

    var descendants = context.querySelectorAll ? context.querySelectorAll('.hero-banner-slider') : [];
    for (var i = 0; i < descendants.length; i++) {
      nodes.push(descendants[i]);
    }

    return nodes;
  }

  function runSectionInitializers(root) {
    var sectionNodes = getSectionNodes(root);

    sectionNodes.forEach(function (sectionEl) {
      var sectionType = sectionEl.getAttribute('data-section-type');
      if (!sectionType) return;

      var initFn = window.SectionInitializers[sectionType];
      if (typeof initFn !== 'function') return;

      try {
        initFn(sectionEl);
        sectionEl.__sectionInitialized = true;
      } catch (err) {
        console.error('Error initializing section:', sectionType, err);
      }
    });
  }

  function initHeroSliders(root) {
    var $ = getJQuery();
    if (!$ || !$.fn || typeof $.fn.slick !== 'function') return;

    var sliders = getHeroSliderNodes(root);
    if (!sliders.length) return;

    sliders.forEach(function (sliderNode) {
      var $slider = $(sliderNode);
      if ($slider.hasClass('slick-initialized')) return;

      var $section = $slider.closest('[id^="shopify-section-"]');
      if (!$section.length) {
        $section = $slider.parent();
      }

      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        appendDots: $section.find('.slide-banner-dots').first(),
        prevArrow: $section.find('.slide-banner-prev').first(),
        nextArrow: $section.find('.slide-banner-next').first(),
        autoplay: false,
        arrows: true,
        dots: true,
        autoplaySpeed: 2000
      });
    });
  }

  function getLinkAccessibleName(link) {
    if (!link) return '';

    var parts = [
      link.getAttribute('aria-label'),
      link.getAttribute('title'),
      link.textContent
    ];

    var images = link.querySelectorAll ? link.querySelectorAll('img[alt]') : [];
    for (var i = 0; i < images.length; i++) {
      parts.push(images[i].getAttribute('alt'));
    }

    return parts
      .filter(function (part) { return typeof part === 'string' && part.trim().length > 0; })
      .join(' ')
      .trim();
  }

  function labelEmptyHashLinks(root) {
    var context = root || document;
    var links = [];

    if (context.nodeType === 1 && context.matches && context.matches('a[href="#"]')) {
      links.push(context);
    }

    var descendants = context.querySelectorAll ? context.querySelectorAll('a[href="#"]') : [];
    for (var i = 0; i < descendants.length; i++) {
      links.push(descendants[i]);
    }

    links.forEach(function (link) {
      if (link.getAttribute('data-tb-empty-hash-link-labeled') === 'true') return;
      if (getLinkAccessibleName(link)) return;
      if (link.querySelector && link.querySelector('button, input, select, textarea')) return;

      link.setAttribute('data-tb-empty-hash-link-labeled', 'true');
      if (!link.getAttribute('role')) link.setAttribute('role', 'button');
      if (!link.getAttribute('aria-label')) link.setAttribute('aria-label', 'Page control');

      var label = document.createElement('span');
      label.className = 'visually-hidden';
      label.textContent = 'Page control';
      link.appendChild(label);

      link.addEventListener('click', function (event) {
        if (link.getAttribute('href') === '#') event.preventDefault();
      });
    });
  }

  function initAll(root) {
    labelEmptyHashLinks(root);
    runSectionInitializers(root);
    initHeroSliders(root);
  }

  function tbInitSlick($slider, options) {
    var $ = getJQuery();
    if (!$ || !$slider || !$slider.length) return;
    if (!$.fn || typeof $.fn.slick !== 'function') {
      console.warn('Slick/jQuery not available when initializing slider:', $slider);
      return;
    }

    if ($slider.hasClass('slick-initialized')) {
      try {
        $slider.slick('unslick');
      } catch (e) {}
    }

    $slider.slick(options);
  }

  function bindSectionResize(container, callback) {
    if (container.__tbResizeHandler) {
      window.removeEventListener('resize', container.__tbResizeHandler);
    }

    var resizeTimer;
    container.__tbResizeHandler = function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(callback, 150);
    };

    window.addEventListener('resize', container.__tbResizeHandler);
  }

  function shouldIgnoreBannerTarget(target, container) {
    if (!target || !container) return false;
    return !!target.closest('a, button, input, select, textarea, summary, label');
  }

  window.SectionInitializers['image-banner-slider-new'] = function (container) {
    if (!container) return;

    var bannerUrl = container.getAttribute('data-banner-url');
    if (!bannerUrl) return;
    if (container.__tbBannerBound) return;

    function navigate(event) {
      if (shouldIgnoreBannerTarget(event.target, container)) return;
      window.location.href = bannerUrl;
    }

    function handleKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      if (shouldIgnoreBannerTarget(event.target, container)) return;
      window.location.href = bannerUrl;
    }

    container.addEventListener('click', navigate);
    container.addEventListener('keydown', handleKeydown);
    container.__tbBannerBound = true;
  };

  window.SectionInitializers['custom-video-feature'] = function (container) {
    var $ = getJQuery();
    if (!$) return;

    var $container = $(container);
    var $slider = $container.find('.video-product');
    if (!$slider.length || $slider.children().length <= 1) return;

    tbInitSlick($slider, {
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      dots: true,
      appendDots: $container.find('.slide-m-dots'),
      prevArrow: $container.find('.slide-m-prev'),
      nextArrow: $container.find('.slide-m-next'),
      adaptiveHeight: true
    });
  };

  function reviewArrowMarkup(direction, label, path) {
    return '<button type="button" class="' + direction + '-arrow gallery-arrows" aria-label="' + label + '" title="' + label + '"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none" aria-hidden="true" focusable="false"><path d="' + path + '" stroke="#252525" stroke-width="2" stroke-linecap="round"/></svg></button>';
  }

  window.SectionInitializers['customer-review'] = function (container) {
    var $ = getJQuery();
    if (!$) return;

    var $c = $(container);
    var $slider = $c.find('.customer-review-wrapper');
    tbInitSlick($slider, {
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      adaptiveHeight: true,
      dots: true,
      prevArrow: reviewArrowMarkup('prev', 'Previous review', 'M27.25 17.5L20.75 24L27.25 30.5'),
      nextArrow: reviewArrowMarkup('next', 'Next review', 'M20.75 17.5L27.25 24L20.75 30.5'),
      responsive: [
        { breakpoint: 1280, settings: { slidesToShow: 3, slidesToScroll: 1, infinite: true, dots: true } },
        { breakpoint: 990, settings: { slidesToShow: 2, slidesToScroll: 1, infinite: true, dots: true } },
        { breakpoint: 767, settings: { slidesToShow: 1, slidesToScroll: 1, infinite: true, dots: true, adaptiveHeight: false } }
      ]
    });
  };

  window.SectionInitializers['product-reviews'] = function (container) {
    window.SectionInitializers['customer-review'](container);
  };

  window.SectionInitializers['home-collection-box'] = function (container) {
    var $ = getJQuery();
    if (!$) return;

    var $c = $(container);
    var $slider = $c.find('.hero-collection-slider');

    function computeSlidesToShow() {
      var w = window.innerWidth || document.documentElement.clientWidth || 0;
      if (w >= 1024) return 3;
      if (w >= 600) return 1.5;
      return 1.1;
    }

    function initSlider() {
      tbInitSlick($slider, {
        infinite: false,
        speed: 800,
        centerMode: false,
        dots: true,
        appendDots: $c.find('.slide-collection-dots'),
        prevArrow: $c.find('.slide-collection-prev'),
        nextArrow: $c.find('.slide-collection-next'),
        slidesToShow: computeSlidesToShow(),
        slidesToScroll: 1
      });
    }

    initSlider();
    bindSectionResize(container, initSlider);
  };

  window.SectionInitializers['custom-best-selling'] = function (container) {
    var $ = getJQuery();
    if (!$) return;

    var $c = $(container);
    var $slider = $c.find('.custom-feature-products-test');

    function computeSlidesToShow() {
      var w = window.innerWidth || document.documentElement.clientWidth || 0;
      if (w >= 1024) return 4;
      if (w >= 600) return 3;
      return 1.2;
    }

    function initSlider() {
      tbInitSlick($slider, {
        infinite: false,
        speed: 800,
        centerMode: false,
        dots: true,
        appendDots: $c.find('.slide-selling-dots'),
        prevArrow: $c.find('.slide-selling-prev'),
        nextArrow: $c.find('.slide-selling-next'),
        slidesToShow: computeSlidesToShow(),
        slidesToScroll: 1
      });
    }

    initSlider();
    bindSectionResize(container, initSlider);
  };

  window.SectionInitializers['product-frequently'] = function (container) {
    var $ = getJQuery();
    if (!$) return;

    var $c = $(container);
    var $slider = $c.find('.product-frequently');

    tbInitSlick($slider, {
      infinite: true,
      speed: 800,
      centerMode: true,
      prevArrow: '<button type="button" class="slick-prev pull-left" aria-label="Previous products" title="Previous products"><svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none" aria-hidden="true" focusable="false"><path d="M6.5 1L1.5 6L6.5 11" stroke="#252525" stroke-width="2" stroke-linecap="round"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next pull-right" aria-label="Next products" title="Next products"><svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none" aria-hidden="true" focusable="false"><path d="M1.5 1L6.5 6L1.5 11" stroke="#252525" stroke-width="2" stroke-linecap="round"/></svg></button>',
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2 } },
        { breakpoint: 600, settings: { slidesToShow: 1 } }
      ]
    });
  };

  window.SectionInitializers['product-stickybar'] = function (container) {
    if (!container) return;

    var navButtons = Array.prototype.slice.call(container.querySelectorAll('.scroll-custom[data-href]'));
    var stickySection = container.closest('#shopify-section-' + container.getAttribute('data-section-id')) || container.closest('.product-sticky-bar-custom') || container.parentElement;
    var stickyBar = stickySection && stickySection.classList.contains('product-sticky-bar-custom') ? stickySection : document.querySelector('.product-sticky-bar-custom');

    function getTarget(button) {
      var selector = button && button.getAttribute('data-href');
      return selector ? document.querySelector(selector) : null;
    }

    function setActiveButton(button) {
      navButtons.forEach(function (item) {
        item.classList.toggle('active', item === button);
      });
    }

    navButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var target = getTarget(button);
        if (!target) return;

        var top = Math.max(target.getBoundingClientRect().top + window.pageYOffset - 20, 0);
        window.scrollTo({ top: top, behavior: 'smooth' });
        setActiveButton(button);
      });
    });

    navButtons = navButtons.filter(function (button) {
      var target = getTarget(button);
      if (target) return true;
      var li = button.closest('li');
      if (li) li.remove();
      return false;
    });

    if (!navButtons.length) {
      container.remove();
      return;
    }

    function syncStickyPosition() {
      if (!stickyBar) return;
      var shouldStick = window.pageYOffset >= 150;
      stickyBar.classList.toggle('now-static', shouldStick);
      stickyBar.classList.toggle('now-absolute', !shouldStick);
      stickyBar.style.position = '';
    }

    function syncStickyBarVisibility() {
      if (!stickyBar) return;
      var shouldHide = document.body.classList.contains('overflow-hiddens') ||
        document.body.classList.contains('overflow-hidden') ||
        document.body.classList.contains('overflow-hidden-tablet');
      stickyBar.style.display = shouldHide ? 'none' : '';
    }

    syncStickyPosition();
    syncStickyBarVisibility();

    if (container.__tbStickyScrollHandler) {
      window.removeEventListener('scroll', container.__tbStickyScrollHandler);
    }
    container.__tbStickyScrollHandler = function () {
      syncStickyPosition();
    };
    window.addEventListener('scroll', container.__tbStickyScrollHandler, { passive: true });

    if (container.__tbBodyObserver) {
      container.__tbBodyObserver.disconnect();
    }
    container.__tbBodyObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'class') {
          syncStickyBarVisibility();
          break;
        }
      }
    });
    container.__tbBodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    if (container.__tbIntersectionObserver) {
      container.__tbIntersectionObserver.disconnect();
    }

    var targets = navButtons.map(getTarget).filter(Boolean);
    if (targets.length) {
      container.__tbIntersectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var selector = '#' + entry.target.id;
          var matchingButton = navButtons.find(function (button) {
            return button.getAttribute('data-href') === selector;
          });
          if (matchingButton) setActiveButton(matchingButton);
        });
      }, {
        root: null,
        rootMargin: '0px 0px -40% 0px',
        threshold: 0.25
      });

      targets.forEach(function (target) {
        container.__tbIntersectionObserver.observe(target);
      });
    }
  };


  window.SectionInitializers['tb-newsletter-popup'] = function (container) {
    if (!container || container.__tbNewsletterPopupBound) return;

    var overlay = container.querySelector('[data-popup-overlay]');
    var dialog = container.querySelector('.tb-newsletter-popup__dialog');
    var closeButtons = container.querySelectorAll('[data-popup-close]');
    var form = container.querySelector('.tb-newsletter-popup__form');
    var emailInput = form ? form.querySelector('input[type="email"]') : null;
    var message = container.querySelector('[data-popup-message]');
    var serverState = container.querySelector('.tb-newsletter-popup__form-state');
    var hasServerSuccess = serverState && serverState.getAttribute('data-server-success') === 'true';
    var hasServerError = serverState && serverState.getAttribute('data-server-error') === 'true';
    var focusableSelector = 'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable="true"]';
    var storageKey = container.getAttribute('data-storage-key') || 'tbNewsletterPopupSuppressed';
    var suppressionDays = parseInt(container.getAttribute('data-suppression-days'), 10) || 30;
    var previousFocus = null;
    var isOpen = false;
    var openedOnce = false;
    var bodyWasLocked = false;
    var desktopExitBound = false;
    var mobileScrollBound = false;

    container.__tbNewsletterPopupBound = true;

    function parseBool(value) {
      return value === true || value === 'true';
    }

    function getNumberAttr(name, fallback) {
      var value = parseFloat(container.getAttribute(name));
      return Number.isFinite(value) ? value : fallback;
    }

    function isMobileViewport() {
      return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    }

    function isSuppressed() {
      try {
        var raw = window.localStorage && window.localStorage.getItem(storageKey);
        if (!raw) return false;

        var parsed = JSON.parse(raw);
        if (parsed && parsed.expiresAt) return Date.now() < parsed.expiresAt;
        if (typeof parsed === 'number') return Date.now() < parsed;
        return raw === 'true';
      } catch (error) {
        return false;
      }
    }

    function setSuppressed() {
      try {
        if (!window.localStorage) return;
        var expiresAt = Date.now() + suppressionDays * 24 * 60 * 60 * 1000;
        window.localStorage.setItem(storageKey, JSON.stringify({ expiresAt: expiresAt }));
      } catch (error) {}
    }

    function isFooterNewsletterTargetActive() {
      return window.location.hash === '#ContactFooter' || window.tbNewsletterAnchorClicked === true;
    }

    function isHeaderNewsletterActive() {
      return window.tbHeaderNewsletterInteracted === true || !!(document.activeElement && document.activeElement.closest && document.activeElement.closest('[data-tb-newsletter-interaction]'));
    }

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var link = target.closest('a[href$="#ContactFooter"]');
      if (link) window.tbNewsletterAnchorClicked = true;

      if (target.closest('[data-tb-newsletter-interaction]')) {
        window.tbHeaderNewsletterInteracted = true;
      }
    });

    document.addEventListener('focusin', function (event) {
      var target = event.target;
      if (target && target.closest && target.closest('[data-tb-newsletter-interaction]')) {
        window.tbHeaderNewsletterInteracted = true;
      }
    });

    document.addEventListener('submit', function (event) {
      var target = event.target;
      if (target && target.closest && target.closest('[data-tb-newsletter-interaction]')) {
        window.tbHeaderNewsletterInteracted = true;
        setSuppressed();
      }
    });

    function getFocusableElements() {
      if (!dialog) return [];
      return Array.prototype.slice.call(dialog.querySelectorAll(focusableSelector)).filter(function (element) {
        return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
      });
    }

    function focusFirstElement() {
      var focusable = getFocusableElements();
      var preferred = emailInput || focusable[0] || dialog;
      if (preferred && preferred.focus) preferred.focus({ preventScroll: true });
    }

    function setMessage(text, state) {
      if (!message) return;
      message.textContent = text || '';
      message.classList.toggle('tb-newsletter-popup__message--error', state === 'error');
      message.classList.toggle('tb-newsletter-popup__message--success', state === 'success');
    }

    function isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    function handleKeydown(event) {
      if (!isOpen) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closePopup(true);
        return;
      }

      if (event.key !== 'Tab') return;

      var focusable = getFocusableElements();
      if (!focusable.length) {
        event.preventDefault();
        if (dialog && dialog.focus) dialog.focus({ preventScroll: true });
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function openPopup(force) {
      if (!overlay || !dialog || isOpen) return;
      if (!force && openedOnce) return;
      if (!force && isSuppressed()) return;

      openedOnce = true;
      isOpen = true;
      previousFocus = document.activeElement;
      bodyWasLocked = document.body.classList.contains('overflow-hidden');
      document.body.classList.add('overflow-hidden');
      overlay.hidden = false;
      document.addEventListener('keydown', handleKeydown);
      window.setTimeout(focusFirstElement, 30);
    }

    function closePopup(shouldSuppress) {
      if (!overlay || !isOpen) return;

      isOpen = false;
      overlay.hidden = true;
      document.removeEventListener('keydown', handleKeydown);

      if (!bodyWasLocked) {
        document.body.classList.remove('overflow-hidden');
      }

      if (shouldSuppress) setSuppressed();

      if (previousFocus && previousFocus.focus) {
        previousFocus.focus({ preventScroll: true });
      }
    }

    function maybeOpen() {
      if (isFooterNewsletterTargetActive() || isHeaderNewsletterActive()) return;
      openPopup(false);
    }

    function bindDesktopExitIntent() {
      if (desktopExitBound || isMobileViewport()) return;
      desktopExitBound = true;
      document.addEventListener('mouseout', function handleExitIntent(event) {
        if (openedOnce || isSuppressed()) {
          document.removeEventListener('mouseout', handleExitIntent);
          return;
        }

        if (event.relatedTarget || event.toElement || event.clientY > 0) return;
        document.removeEventListener('mouseout', handleExitIntent);
        maybeOpen();
      });
    }

    function bindMobileScrollDepth() {
      if (mobileScrollBound || !isMobileViewport()) return;
      mobileScrollBound = true;

      var threshold = getNumberAttr('data-mobile-scroll-depth', 50) / 100;
      window.addEventListener('scroll', function handleScrollDepth() {
        if (openedOnce || isSuppressed()) {
          window.removeEventListener('scroll', handleScrollDepth);
          return;
        }

        var doc = document.documentElement;
        var scrollable = Math.max(doc.scrollHeight - window.innerHeight, 1);
        var depth = (window.pageYOffset || doc.scrollTop || 0) / scrollable;
        if (depth < threshold) return;

        window.removeEventListener('scroll', handleScrollDepth);
        maybeOpen();
      }, { passive: true });
    }

    if (!parseBool(container.getAttribute('data-enabled'))) return;
    if (parseBool(container.getAttribute('data-homepage-only')) && !parseBool(container.getAttribute('data-is-homepage'))) return;
    if (!overlay || !dialog) return;

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        closePopup(true);
      });
    });

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) {
        closePopup(true);
      }
    });

    if (form && emailInput) {
      form.addEventListener('submit', function (event) {
        var email = emailInput.value ? emailInput.value.trim() : '';

        if (!isValidEmail(email)) {
          event.preventDefault();
          emailInput.setAttribute('aria-invalid', 'true');
          setMessage('Enter a valid email address so we can send the right updates.', 'error');
          emailInput.focus();
          return;
        }

        emailInput.removeAttribute('aria-invalid');
        setMessage('', null);

        var submitButton = form.querySelector('[type="submit"]');
        if (submitButton) submitButton.disabled = true;

        if (!serverState) {
          setSuppressed();
        }
      });
    }

    if (hasServerSuccess) {
      setSuppressed();
      openPopup(true);
      return;
    }

    if (hasServerError) {
      openPopup(true);
      return;
    }

    if (isSuppressed()) return;

    var delaySeconds = isMobileViewport()
      ? getNumberAttr('data-mobile-delay-seconds', 12)
      : getNumberAttr('data-delay-seconds', 7);

    window.setTimeout(maybeOpen, Math.max(delaySeconds, 0) * 1000);
    bindDesktopExitIntent();
    bindMobileScrollDepth();
  };


  window.SectionInitializers['comparison-builder'] = function (container) {
    if (!container || container.__tbComparisonBuilderBound) return;
    container.__tbComparisonBuilderBound = true;

    var dataNode = container.querySelector('[data-comparison-products]');
    var products = [];

    try {
      products = dataNode ? JSON.parse(dataNode.textContent || '[]') : [];
    } catch (error) {
      console.error('Thermal Bros comparison data could not be parsed.', error);
      products = [];
    }

    function hasBlockedTitle(product) {
      return /\b(demo|used|refurbished|refurb|pre[-\s]?owned)\b/i.test((product && product.title) || '');
    }

    products = products.filter(function (product) {
      return product && product.handle && !product.hidden && !hasBlockedTitle(product);
    });

    var configNode = container.querySelector('[data-comparison-builder-config]');
    var builderConfig = {};
    try {
      builderConfig = configNode ? JSON.parse(configNode.textContent || '{}') : {};
    } catch (error) {
      console.error('Thermal Bros comparison builder settings could not be parsed.', error);
      builderConfig = {};
    }

    function configText(key, fallback) {
      var value = builderConfig && builderConfig[key];
      if (value === null || value === undefined || value === '') return fallback;
      if (Array.isArray(value)) return value.join('|');
      return String(value);
    }

    function tokenText(key, fallback, values) {
      var output = configText(key, fallback);
      values = values || {};
      Object.keys(values).forEach(function (name) {
        output = output.replace(new RegExp('\\{' + name + '\\}', 'g'), values[name]);
      });
      return output;
    }

    var leftSelect = container.querySelector('[data-compare-left]');
    var rightSelect = container.querySelector('[data-compare-right]');
    var filterNodes = Array.prototype.slice.call(container.querySelectorAll('[data-filter]'));
    var countNode = container.querySelector('[data-product-count]');
    var emptyNode = container.querySelector('[data-empty-state]');
    var resultsNode = container.querySelector('[data-results]');
    var cardsNode = container.querySelector('[data-product-cards]');
    var recommendationNode = container.querySelector('[data-recommendation]');
    var decisionCardsNode = container.querySelector('[data-decision-cards]');
    var buyerTableNode = container.querySelector('[data-buyer-table]');
    var specTableNode = container.querySelector('[data-spec-table]');
    var visualComparisonNode = container.querySelector('[data-visual-comparison]');
    var fieldGuideNode = container.querySelector('[data-field-guide]');
    var swapButton = container.querySelector('[data-swap-products]');
    var copyButton = container.querySelector('[data-copy-share-link]');

    if (!leftSelect || !rightSelect) return;

    function toText(value) {
      if (value === null || value === undefined || value === false) return '';
      if (Array.isArray(value)) {
        return value.map(toText).filter(Boolean).join(' x ');
      }
      if (typeof value === 'object') {
        if (value.value !== undefined && value.unit !== undefined) return String(value.value) + String(value.unit);
        if (value.value !== undefined) return toText(value.value);
        return Object.keys(value).map(function (key) { return toText(value[key]); }).filter(Boolean).join(' ');
      }
      return String(value).trim();
    }

    function normalize(value) {
      return toText(value).toLowerCase();
    }

    function escapeHtml(value) {
      return toText(value).replace(/[&<>'"]/g, function (character) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          "'": '&#39;',
          '"': '&quot;'
        }[character];
      });
    }

    function display(value, fallback) {
      var text = toText(value);
      return text || fallback || configText('notListed', 'Not listed');
    }

    function money(cents) {
      var number = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(number);
      } catch (error) {
        return '$' + number.toFixed(2);
      }
    }

    function productSearchText(product) {
      return normalize([
        product.title,
        product.vendor,
        product.brand,
        product.product_type,
        product.tags,
        product.collection_buckets,
        product.best_for,
        product.not_ideal_for,
        product.primary_use_case,
        product.terrain_fit,
        product.distance_fit,
        product.budget_fit,
        product.staff_verdict
      ].join(' '));
    }

    function hasRangefinder(product) {
      var rangeText = normalize(product.rangefinder);
      var allText = normalize([product.title, product.tags, product.collection_buckets].join(' '));
      if (/\b(no|none|without)\b/.test(rangeText) && allText.indexOf('lrf') === -1 && allText.indexOf('rangefinder') === -1) return false;
      return rangeText.indexOf('yes') !== -1 || allText.indexOf('lrf') !== -1 || allText.indexOf('rangefinder') !== -1 || allText.indexOf('range finder') !== -1;
    }

    function isClipOn(product) {
      var text = normalize([product.clip_on, product.product_type, product.title, product.tags, product.collection_buckets].join(' '));
      if (text.indexOf('not clip') !== -1 || text.indexOf('no clip') !== -1) return false;
      return text.indexOf('clip-on') !== -1 || text.indexOf('clip on') !== -1;
    }

    function opticFamily(product) {
      var text = productSearchText(product);
      if (text.indexOf('clip-on') !== -1 || text.indexOf('clip on') !== -1) return 'Clip-on setup';
      if (text.indexOf('handheld') !== -1 || text.indexOf('monocular') !== -1 || text.indexOf('scanner') !== -1) return 'Handheld scanner';
      if (text.indexOf('binocular') !== -1 || text.indexOf('dual-eye') !== -1 || text.indexOf('dual eye') !== -1) return 'Binocular / dual-eye optic';
      if (text.indexOf('helmet') !== -1 || text.indexOf('goggle') !== -1) return 'Helmet / night vision setup';
      if (text.indexOf('ptz') !== -1 || text.indexOf('camera') !== -1 || text.indexOf('monitoring') !== -1) return 'PTZ / monitoring optic';
      if (text.indexOf('drone') !== -1) return 'Thermal drone';
      if (text.indexOf('night vision') !== -1 || text.indexOf('nightvision') !== -1) return 'Night vision optic';
      if (text.indexOf('scope') !== -1 || normalize(product.product_type).indexOf('scope') !== -1) return 'Thermal riflescope';
      return toText(product.product_type) || 'Thermal / night vision product';
    }

    function resolutionClass(product) {
      var text = normalize(product.sensor_resolution || product.title || '');
      if (text.indexOf('1280') !== -1 || text.indexOf('1024') !== -1) return '1280';
      if (text.indexOf('640') !== -1) return '640';
      if (text.indexOf('384') !== -1) return '384';
      if (text.indexOf('256') !== -1) return '256';
      return '';
    }

    function resolutionRank(product) {
      var cls = resolutionClass(product);
      if (cls === '1280') return 4;
      if (cls === '640') return 3;
      if (cls === '384') return 2;
      if (cls === '256') return 1;
      return 0;
    }

    function budgetClass(product) {
      var price = Number(product.price || 0);
      if (price > 0 && price < 200000) return 'under-2000';
      if (price >= 200000 && price < 350000) return '2000-3500';
      if (price >= 350000 && price < 500000) return '3500-5000';
      if (price >= 500000 && price < 650000) return '5000-6500';
      if (price >= 650000) return 'over-6500';
      return '';
    }

    function budgetLabel(product) {
      var cls = budgetClass(product);
      if (cls === 'under-2000') return 'Thermals Under $2,000';
      if (cls === '2000-3500') return 'Thermal Scopes $2,000-$3,500';
      if (cls === '3500-5000') return 'Thermal Scopes $3,500-$5,000';
      if (cls === '5000-6500') return 'Thermal Scopes and Handhelds $5,000-$6,500';
      if (cls === 'over-6500') return 'Premium Thermals Over $6,500';
      return 'Budget not listed';
    }

    function numericFromText(value) {
      var match = toText(value).replace(/,/g, '').match(/\d+(\.\d+)?/);
      return match ? Number(match[0]) : 0;
    }

    function pixelsFromResolution(value) {
      var text = toText(value).replace(/,/g, '').toLowerCase();
      var match = text.match(/(\d{3,4})\s*[x×]\s*(\d{3,4})/);
      if (!match) return 0;
      return Number(match[1]) * Number(match[2]);
    }

    function formatCompactNumber(value) {
      var number = Number(value || 0);
      try {
        return new Intl.NumberFormat('en-US', { maximumFractionDigits: 1 }).format(number);
      } catch (error) {
        return String(number);
      }
    }

    function distanceClass(product) {
      var explicit = normalize(product.distance_fit);
      if (explicit.indexOf('inside 100') !== -1) return 'inside-100';
      if (explicit.indexOf('100-200') !== -1) return '100-200';
      if (explicit.indexOf('200-300') !== -1) return '200-300';
      if (explicit.indexOf('300+') !== -1 || explicit.indexOf('long-range') !== -1 || explicit.indexOf('long range') !== -1) return '300-plus';
      var yards = numericFromText(product.detection_range);
      if (!yards) return '';
      if (yards < 1000) return 'inside-100';
      if (yards < 2000) return '100-200';
      if (yards < 3000) return '200-300';
      return '300-plus';
    }

    function distanceLabel(product) {
      var explicit = toText(product.distance_fit);
      if (explicit) return explicit;
      var cls = distanceClass(product);
      if (cls === 'inside-100') return 'Inside 100 yards / close-range fit';
      if (cls === '100-200') return '100-200 yards';
      if (cls === '200-300') return '200-300 yards';
      if (cls === '300-plus') return '300+ yards / long-range identification';
      return toText(product.detection_range) || 'Not listed';
    }

    function useCaseMatches(product, value) {
      if (!value) return true;
      var text = productSearchText(product);
      var map = {
        'first-thermal': ['first thermal', 'entry', 'simple setup'],
        'budget': ['budget', 'under $2,000', 'lowest-cost', 'value'],
        'best-resolution': ['best resolution', 'premium resolution', '1280', '640'],
        'hog': ['hog'],
        'coyote': ['coyote', 'predator'],
        'long-range': ['long-range', 'long range', '300+', 'identification'],
        'rangefinder': ['rangefinder', 'range finder', 'lrf'],
        'handheld': ['handheld', 'monocular', 'scanner', 'scanning'],
        'clip-on': ['clip-on', 'clip on'],
        'helmet': ['helmet'],
        'ranch': ['ranch', 'property', 'monitoring', 'ptz'],
        'rental': ['rental', 'rent']
      };
      return (map[value] || [value]).some(function (needle) { return text.indexOf(needle) !== -1; });
    }

    function terrainMatches(product, value) {
      if (!value) return true;
      var text = productSearchText(product);
      var map = {
        'timber': ['timber', 'woods', 'tight'],
        'mixed': ['mixed'],
        'open': ['open', 'field', 'fields'],
        'crop': ['crop'],
        'ranch': ['ranch', 'pasture', 'property'],
        'vehicle': ['vehicle', 'mounted'],
        'helmet': ['helmet', 'mobile'],
        'fixed': ['fixed', 'monitoring', 'ptz']
      };
      return (map[value] || [value]).some(function (needle) { return text.indexOf(needle) !== -1; });
    }

    function getFilters() {
      var filters = {};
      filterNodes.forEach(function (node) {
        filters[node.getAttribute('data-filter')] = node.value || '';
      });
      return filters;
    }

    function setFilters(values) {
      filterNodes.forEach(function (node) {
        var key = node.getAttribute('data-filter');
        if (values[key] !== undefined) node.value = values[key];
      });
    }

    function productMatchesFilters(product) {
      var filters = getFilters();
      if (filters.product_type && product.product_type !== filters.product_type) return false;
      if (filters.brand && toText(product.brand || product.vendor) !== filters.brand) return false;
      if (filters.budget && budgetClass(product) !== filters.budget) return false;
      if (filters.resolution && resolutionClass(product) !== filters.resolution) return false;
      if (filters.rangefinder === 'yes' && !hasRangefinder(product)) return false;
      if (filters.rangefinder === 'no' && hasRangefinder(product)) return false;
      if (filters.clip_on === 'yes' && !isClipOn(product)) return false;
      if (filters.clip_on === 'no' && isClipOn(product)) return false;
      if (filters.distance && distanceClass(product) !== filters.distance) return false;
      if (filters.use_case && !useCaseMatches(product, filters.use_case)) return false;
      if (filters.terrain && !terrainMatches(product, filters.terrain)) return false;
      return true;
    }

    function uniqueSorted(list) {
      var seen = {};
      list.forEach(function (value) {
        value = toText(value);
        if (value) seen[value] = true;
      });
      return Object.keys(seen).sort(function (a, b) { return a.localeCompare(b); });
    }

    function addOptions(select, values, selected) {
      if (!select) return;
      var first = select.options[0] ? select.options[0].cloneNode(true) : null;
      select.innerHTML = '';
      if (first) select.appendChild(first);
      values.forEach(function (value) {
        var option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });
      if (selected) select.value = selected;
    }

    function populateStaticFilterOptions() {
      var typeSelect = container.querySelector('[data-filter="product_type"]');
      var brandSelect = container.querySelector('[data-filter="brand"]');
      var useCaseSelect = container.querySelector('[data-filter="use_case"]');
      var distanceSelect = container.querySelector('[data-filter="distance"]');
      var terrainSelect = container.querySelector('[data-filter="terrain"]');

      addOptions(typeSelect, uniqueSorted(products.map(function (product) { return product.product_type; })), typeSelect && typeSelect.value);
      addOptions(brandSelect, uniqueSorted(products.map(function (product) { return product.brand || product.vendor; })), brandSelect && brandSelect.value);

      if (useCaseSelect && useCaseSelect.options.length <= 1) {
        [
          ['first-thermal', 'First thermal scope'],
          ['budget', 'Budget thermal scope'],
          ['best-resolution', 'Best resolution'],
          ['hog', 'Hog hunting'],
          ['coyote', 'Coyote / predator hunting'],
          ['long-range', 'Long-range identification'],
          ['rangefinder', 'Built-in rangefinder'],
          ['handheld', 'Handheld scanning'],
          ['clip-on', 'Clip-on setup'],
          ['helmet', 'Helmet-mounted use'],
          ['ranch', 'Ranch / property monitoring'],
          ['rental', 'Rental / test before buying']
        ].forEach(function (item) {
          var option = document.createElement('option');
          option.value = item[0];
          option.textContent = item[1];
          useCaseSelect.appendChild(option);
        });
      }

      if (distanceSelect && distanceSelect.options.length <= 1) {
        [
          ['inside-100', 'Inside 100 yards'],
          ['100-200', '100-200 yards'],
          ['200-300', '200-300 yards'],
          ['300-plus', '300+ yards / long-range ID']
        ].forEach(function (item) {
          var option = document.createElement('option');
          option.value = item[0];
          option.textContent = item[1];
          distanceSelect.appendChild(option);
        });
      }

      if (terrainSelect && terrainSelect.options.length <= 1) {
        [
          ['timber', 'Timber'],
          ['mixed', 'Mixed terrain'],
          ['open', 'Open fields'],
          ['crop', 'Crop fields'],
          ['ranch', 'Ranch / pasture'],
          ['vehicle', 'Vehicle-mounted'],
          ['helmet', 'Helmet-mounted / mobile'],
          ['fixed', 'Fixed-position monitoring']
        ].forEach(function (item) {
          var option = document.createElement('option');
          option.value = item[0];
          option.textContent = item[1];
          terrainSelect.appendChild(option);
        });
      }
    }

    function getProduct(handle) {
      return products.find(function (product) { return product.handle === handle; }) || null;
    }

    function filteredProducts() {
      return products.filter(productMatchesFilters);
    }

    function populateProductSelects(list) {
      var currentLeft = leftSelect.value;
      var currentRight = rightSelect.value;
      [leftSelect, rightSelect].forEach(function (select) {
        select.innerHTML = '';
        list.forEach(function (product) {
          var option = document.createElement('option');
          option.value = product.handle;
          option.textContent = product.title;
          select.appendChild(option);
        });
      });

      if (list.some(function (product) { return product.handle === currentLeft; })) leftSelect.value = currentLeft;
      if (list.some(function (product) { return product.handle === currentRight; })) rightSelect.value = currentRight;
      if (!leftSelect.value && list[0]) leftSelect.value = list[0].handle;
      if (!rightSelect.value && list[1]) rightSelect.value = list[1].handle;
      if (leftSelect.value === rightSelect.value && list.length > 1) {
        rightSelect.value = list.find(function (product) { return product.handle !== leftSelect.value; }).handle;
      }
    }

    function buildProductForm(product) {
      var variantId = toText(product.selected_or_first_available_variant_id);
      var disabled = !product.available || !variantId;
      var formId = 'tb-builder-form-' + product.handle;
      var action = (window.routes && window.routes.cart_add_url) || '/cart/add';
      return '' +
        '<product-form class="product-form" data-section-id="' + escapeHtml(container.getAttribute('data-section-id') || 'comparison-builder') + '">' +
          '<div class="product-form__error-message-wrapper" role="alert" hidden><span class="product-form__error-message"></span></div>' +
          '<form method="post" action="' + escapeHtml(action) + '" id="' + escapeHtml(formId) + '" class="form" novalidate="novalidate" data-type="add-to-cart-form">' +
            '<input type="hidden" name="id" value="' + escapeHtml(variantId) + '" class="product-variant-id"' + (disabled ? ' disabled' : '') + '>' +
            '<button type="submit" name="add" class="product-form__submit button button--full-width button--primary"' + (disabled ? ' disabled' : '') + '>' +
              '<span>' + (disabled ? configText('soldOut', 'Sold out') : configText('addToCart', 'Add to cart')) + '</span>' +
              '<div class="loading__spinner hidden" aria-hidden="true"></div>' +
            '</button>' +
          '</form>' +
        '</product-form>';
    }

    function specList(product) {
      var specs = [
        [configText('miniSpecSensor', 'Sensor'), product.sensor_resolution],
        [configText('miniSpecObjective', 'Objective'), product.objective_lens],
        [configText('miniSpecMagnification', 'Magnification'), [product.base_magnification, product.max_magnification].filter(Boolean).join(' to ')],
        [configText('miniSpecDetection', 'Detection'), product.detection_range],
        [configText('miniSpecBattery', 'Battery'), product.battery_life],
        [configText('miniSpecWeight', 'Weight'), product.weight],
        [configText('miniSpecRangefinder', 'Rangefinder'), product.rangefinder]
      ];
      return specs.filter(function (row) { return toText(row[1]); }).map(function (row) {
        return '<div><dt>' + escapeHtml(row[0]) + '</dt><dd>' + escapeHtml(toText(row[1])) + '</dd></div>';
      }).join('');
    }

    function productCard(product, label) {
      var typeLabel = opticFamily(product);
      var priceHtml = money(product.price);
      return '' +
        '<article class="tb-compare-card" data-product-handle="' + escapeHtml(product.handle) + '">' +
          '<div class="tb-compare-card__media">' + (product.image ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '<div class="tb-compare-card__placeholder" aria-hidden="true"></div>') + '</div>' +
          '<div class="tb-compare-card__body">' +
            '<p class="tb-eyebrow">' + escapeHtml(label) + '</p>' +
            '<h3 class="tb-compare-card__title"><a href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a></h3>' +
            '<p class="tb-compare-card__meta">' + escapeHtml(product.brand || product.vendor || '') + ' / ' + escapeHtml(typeLabel) + '</p>' +
            '<div class="tb-compare-card__price">' + priceHtml + '</div>' +
            '<p class="tb-availability' + (!product.available ? ' tb-availability--out' : '') + '">' + (product.available ? configText('inStock', 'In stock or available to order') : configText('unavailable', 'Currently unavailable')) + '</p>' +
            (product.best_for ? '<p class="tb-fit-note"><strong>' + escapeHtml(configText('bestForLabel', 'Best for')) + ':</strong> ' + escapeHtml(product.best_for) + '</p>' : '') +
            (product.not_ideal_for ? '<p class="tb-fit-note"><strong>' + escapeHtml(configText('skipIfLabel', 'Skip this if')) + ':</strong> ' + escapeHtml(product.not_ideal_for) + '</p>' : '') +
            '<dl class="tb-mini-specs">' + specList(product) + '</dl>' +
            '<div class="tb-compare-card__actions">' + buildProductForm(product) + '<a class="button button--secondary button--full-width" href="' + escapeHtml(product.url) + '">' + escapeHtml(configText('viewDetails', 'View full product details')) + '</a></div>' +
          '</div>' +
        '</article>';
    }

    function betterResolution(left, right) {
      var leftRank = resolutionRank(left);
      var rightRank = resolutionRank(right);
      if (leftRank > rightRank) return left;
      if (rightRank > leftRank) return right;
      return null;
    }

    function sameDecisionFamily(left, right) {
      return opticFamily(left) === opticFamily(right) || normalize(left.product_type) === normalize(right.product_type);
    }

    function comparisonSummary(left, right) {
      var leftPrice = Number(left.price || 0);
      var rightPrice = Number(right.price || 0);
      var cheaper = leftPrice <= rightPrice ? left : right;
      var higher = cheaper === left ? right : left;
      var diff = Math.abs(leftPrice - rightPrice);
      var resolutionWinner = betterResolution(left, right);
      var leftLrf = hasRangefinder(left);
      var rightLrf = hasRangefinder(right);
      var lrfWinner = leftLrf && !rightLrf ? left : (!leftLrf && rightLrf ? right : null);
      return {
        cheaper: cheaper,
        higher: higher,
        diff: diff,
        sameFamily: sameDecisionFamily(left, right),
        resolutionWinner: resolutionWinner,
        lrfWinner: lrfWinner,
        leftLrf: leftLrf,
        rightLrf: rightLrf
      };
    }

    function buildRecommendation(left, right) {
      if (!left || !right) return '';
      var summary = comparisonSummary(left, right);
      var lead = '';
      var support = [];

      if (!summary.sameFamily) {
        lead = tokenText('recommendationDifferentFormatLead', 'Choose the product format first. {left_family} and {right_family} solve different jobs, so price should not decide until the format matches how you will actually hunt or scan.', {
          left_family: opticFamily(left),
          right_family: opticFamily(right)
        });
      } else if (summary.diff > 0) {
        lead = tokenText('recommendationCheaperLead', 'Start with {cheaper_title} if both products solve your same hunt. It costs {price_difference} less based on the current displayed prices.', {
          cheaper_title: summary.cheaper.title,
          price_difference: money(summary.diff)
        });
      } else {
        lead = configText('recommendationClosePriceLead', 'These two products are close on displayed price. Decide by use case, rangefinder need, handling, and image confidence instead of chasing a spec-sheet win.');
      }

      if (summary.resolutionWinner && summary.resolutionWinner !== summary.cheaper) {
        support.push(tokenText('recommendationResolutionSupport', 'Pay more for {product_title} only if its listed resolution gives you useful identification confidence in your terrain.', { product_title: summary.resolutionWinner.title }));
      }
      if (summary.lrfWinner && summary.lrfWinner !== summary.cheaper) {
        support.push(tokenText('recommendationLrfSupport', 'Pay more for {product_title} only if built-in rangefinding matters before the shot.', { product_title: summary.lrfWinner.title }));
      }
      if (!support.length) {
        support.push(configText('recommendationDefaultSupport', 'If both solve the problem, the cheaper one probably wins.'));
      }

      var checks = builderConfig.recommendationChecks && builderConfig.recommendationChecks.length ? builderConfig.recommendationChecks : ['Use case first', 'Format match', 'Distance and terrain', 'LRF need', 'Cost last'];
      var heading = summary.sameFamily && summary.diff > 0 ? configText('recommendationSameFamilyTitlePrefix', 'Best value starts with') + ' ' + summary.cheaper.title : configText('recommendationFallbackTitle', 'Start with the job, then the price');
      return '' +
        '<p class="tb-eyebrow">' + escapeHtml(configText('recommendationEyebrow', 'Plain-English recommendation')) + '</p>' +
        '<h2>' + escapeHtml(heading) + '</h2>' +
        '<p>' + escapeHtml(lead + ' ' + support.join(' ')) + '</p>' +
        '<div class="tb-recommendation__checks" aria-label="Recommendation logic">' +
          checks.map(function (check) { return '<span>' + escapeHtml(check) + '</span>'; }).join('') +
        '</div>';
    }

    function verdictCard(label, value, copy) {
      return '<article><span>' + escapeHtml(label) + '</span><strong>' + escapeHtml(value) + '</strong>' + (copy ? '<p>' + escapeHtml(copy) + '</p>' : '') + '</article>';
    }

    function visualMetricCard(metric, left, right) {
      var leftValue = Number(metric.leftValue || 0);
      var rightValue = Number(metric.rightValue || 0);
      var leftDisplay = metric.leftDisplay || display(metric.leftRaw);
      var rightDisplay = metric.rightDisplay || display(metric.rightRaw);
      var hasNumbers = leftValue > 0 && rightValue > 0;
      var winner = 'tie';
      if (hasNumbers && leftValue !== rightValue) {
        if (metric.higherBetter) winner = leftValue > rightValue ? 'left' : 'right';
        else winner = leftValue < rightValue ? 'left' : 'right';
      }
      var max = Math.max(leftValue, rightValue, 1);
      var leftWidth = hasNumbers ? Math.max(6, Math.round((leftValue / max) * 100)) : 0;
      var rightWidth = hasNumbers ? Math.max(6, Math.round((rightValue / max) * 100)) : 0;
      var helper = metric.higherBetter ? configText('visualHigherBetterLabel', 'Higher listed number is usually better here') : configText('visualLowerBetterLabel', 'Lower listed number is usually better here');
      var winnerTitle = winner === 'left' ? left.title : (winner === 'right' ? right.title : '');
      var note = metric.note || '';
      var resultText = '';
      if (!hasNumbers) {
        resultText = configText('visualNotEnoughData', 'Not enough clean numeric data to render a reliable slider. Displayed values are still shown.');
      } else if (winner === 'tie') {
        resultText = configText('visualTieTemplate', 'These two are close or the data is not specific enough to call a visual winner.');
      } else {
        resultText = tokenText('visualWinnerTemplate', '{winner_title} has the visual edge on this metric.', { winner_title: winnerTitle });
      }

      function row(side, product, width, displayValue) {
        var isWinner = winner === side;
        var productLabel = side === 'left' ? configText('visualLeftLabel', 'Product A') : configText('visualRightLabel', 'Product B');
        var colorClass = side === 'left' ? 'tb-visual-bar__fill--left' : 'tb-visual-bar__fill--right';
        return '' +
          '<div class="tb-visual-bar-row' + (isWinner ? ' is-winner' : '') + '">' +
            '<div class="tb-visual-bar-row__label"><span>' + escapeHtml(productLabel) + '</span><strong>' + escapeHtml(product.title) + '</strong></div>' +
            '<div class="tb-visual-bar" aria-hidden="true"><span class="tb-visual-bar__fill ' + colorClass + '" style="width: ' + width + '%"></span></div>' +
            '<b class="tb-visual-bar-row__value">' + escapeHtml(displayValue) + '</b>' +
          '</div>';
      }

      return '' +
        '<article class="tb-visual-metric">' +
          '<div class="tb-visual-metric__top"><div><h3>' + escapeHtml(metric.label) + '</h3><p>' + escapeHtml(helper) + '</p></div>' + (winner !== 'tie' && hasNumbers ? '<span class="tb-visual-winner">' + escapeHtml(winnerTitle) + '</span>' : '<span class="tb-visual-winner tb-visual-winner--muted">' + escapeHtml(configText('visualTieLabel', 'No clear visual advantage')) + '</span>') + '</div>' +
          '<div class="tb-visual-bars">' +
            row('left', left, leftWidth, leftDisplay) +
            row('right', right, rightWidth, rightDisplay) +
          '</div>' +
          '<p class="tb-visual-metric__result">' + escapeHtml(resultText) + '</p>' +
          (note ? '<p class="tb-visual-metric__note">' + escapeHtml(note) + '</p>' : '') +
        '</article>';
    }

    function visualBooleanCard(label, note, leftBool, rightBool, left, right) {
      var yes = configText('visualYesLabel', 'Yes');
      var no = configText('visualNoLabel', 'No');
      return '' +
        '<article class="tb-visual-metric tb-visual-metric--boolean">' +
          '<div class="tb-visual-metric__top"><div><h3>' + escapeHtml(label) + '</h3><p>' + escapeHtml(note) + '</p></div></div>' +
          '<div class="tb-visual-toggle-grid">' +
            '<div class="' + (leftBool ? 'is-active' : '') + '"><span>' + escapeHtml(configText('visualLeftLabel', 'Product A')) + '</span><strong>' + escapeHtml(left.title) + '</strong><b>' + escapeHtml(leftBool ? yes : no) + '</b></div>' +
            '<div class="' + (rightBool ? 'is-active' : '') + '"><span>' + escapeHtml(configText('visualRightLabel', 'Product B')) + '</span><strong>' + escapeHtml(right.title) + '</strong><b>' + escapeHtml(rightBool ? yes : no) + '</b></div>' +
          '</div>' +
        '</article>';
    }

    function buildVisualComparison(left, right) {
      var enabled = builderConfig.visualMetrics || {};
      var metricHtml = [];

      if (enabled.price !== false) {
        metricHtml.push(visualMetricCard({
          label: configText('visualPriceLabel', 'Current displayed price'),
          leftValue: Number(left.price || 0),
          rightValue: Number(right.price || 0),
          leftDisplay: money(left.price),
          rightDisplay: money(right.price),
          higherBetter: false,
          note: configText('visualPriceNote', 'Lower price matters when both products solve the same real-world use case.')
        }, left, right));
      }

      if (enabled.resolution !== false) {
        var leftPixels = pixelsFromResolution(left.sensor_resolution);
        var rightPixels = pixelsFromResolution(right.sensor_resolution);
        metricHtml.push(visualMetricCard({
          label: configText('visualResolutionLabel', 'Sensor resolution'),
          leftValue: leftPixels,
          rightValue: rightPixels,
          leftDisplay: display(left.sensor_resolution),
          rightDisplay: display(right.sensor_resolution),
          higherBetter: true,
          note: configText('visualResolutionNote', 'More sensor pixels can help with identification confidence, but only when the field use justifies it.')
        }, left, right));
      }

      if (enabled.detection !== false) {
        metricHtml.push(visualMetricCard({
          label: configText('visualDetectionLabel', 'Listed detection range'),
          leftValue: numericFromText(left.detection_range),
          rightValue: numericFromText(right.detection_range),
          leftRaw: left.detection_range,
          rightRaw: right.detection_range,
          higherBetter: true,
          note: configText('visualDetectionNote', 'Detection range is not the same as confident identification or ethical shooting distance.')
        }, left, right));
      }

      if (enabled.battery !== false) {
        metricHtml.push(visualMetricCard({
          label: configText('visualBatteryLabel', 'Battery life'),
          leftValue: numericFromText(left.battery_life),
          rightValue: numericFromText(right.battery_life),
          leftRaw: left.battery_life,
          rightRaw: right.battery_life,
          higherBetter: true,
          note: configText('visualBatteryNote', 'More runtime helps on longer sits, cold weather hunts, and nights where external power is annoying.')
        }, left, right));
      }

      if (enabled.weight !== false) {
        metricHtml.push(visualMetricCard({
          label: configText('visualWeightLabel', 'Weight / handling'),
          leftValue: numericFromText(left.weight),
          rightValue: numericFromText(right.weight),
          leftRaw: left.weight,
          rightRaw: right.weight,
          higherBetter: false,
          note: configText('visualWeightNote', 'Lower weight usually helps when carrying, scanning, or building a lighter rifle setup.')
        }, left, right));
      }

      if (enabled.objective !== false) {
        metricHtml.push(visualMetricCard({
          label: configText('visualObjectiveLabel', 'Objective lens'),
          leftValue: numericFromText(left.objective_lens),
          rightValue: numericFromText(right.objective_lens),
          leftRaw: left.objective_lens,
          rightRaw: right.objective_lens,
          higherBetter: true,
          note: configText('visualObjectiveNote', 'Larger objective lenses can help at distance, but they may add size, weight, and cost.')
        }, left, right));
      }

      if (enabled.baseMag !== false) {
        metricHtml.push(visualMetricCard({
          label: configText('visualBaseMagLabel', 'Base magnification'),
          leftValue: numericFromText(left.base_magnification),
          rightValue: numericFromText(right.base_magnification),
          leftRaw: left.base_magnification,
          rightRaw: right.base_magnification,
          higherBetter: true,
          note: configText('visualBaseMagNote', 'Higher base magnification can help in open fields; lower base magnification is often easier in tighter terrain.')
        }, left, right));
      }

      if (enabled.rangefinder !== false) {
        metricHtml.push(visualBooleanCard(configText('visualRangefinderLabel', 'Built-in rangefinder'), configText('visualRangefinderNote', 'LRF is worth paying for when distance confirmation changes the shot. It is overkill when your distances are short and known.'), hasRangefinder(left), hasRangefinder(right), left, right));
      }

      if (!metricHtml.length) return '';
      return '' +
        '<div class="tb-visual-comparison__header">' +
          '<p class="tb-eyebrow">' + escapeHtml(configText('visualEyebrow', 'Visual trade-offs')) + '</p>' +
          '<h2>' + escapeHtml(configText('visualHeading', 'Visual side-by-side comparison')) + '</h2>' +
          '<p>' + escapeHtml(configText('visualIntro', 'These bars make the trade-offs easier to see. They are a visual aid, not a fake score. Use them with the plain-English recommendation above.')) + '</p>' +
        '</div>' +
        '<div class="tb-visual-metrics">' + metricHtml.join('') + '</div>';
    }

    function buildDecisionCards(left, right) {
      var summary = comparisonSummary(left, right);
      var valueText = summary.diff > 0 ? summary.cheaper.title : 'Tie on current displayed price';
      var resolutionText = summary.resolutionWinner ? summary.resolutionWinner.title : 'Tie or not listed';
      var lrfText = summary.leftLrf && summary.rightLrf ? 'Both list built-in LRF' : (summary.lrfWinner ? summary.lrfWinner.title : 'Neither lists built-in LRF');
      var mostPeople = summary.sameFamily ? (summary.diff > 0 ? summary.cheaper.title : 'Match to use case') : 'Choose the correct product format first';
      return '' +
        '<h2>' + escapeHtml(configText('decisionHeading', 'Verdict cards')) + '</h2>' +
        '<div class="tb-verdict-grid">' +
          verdictCard(configText('decisionBestMostLabel', 'Best for most people'), mostPeople, summary.sameFamily ? configText('decisionBestMostCopy', 'Use the cheaper option when both solve the same field problem.') : configText('decisionDifferentFormatCopy', 'Do not compare a scanner, clip-on, rifle scope, and binocular like they are the same tool.')) +
          verdictCard(configText('decisionBetterValueLabel', 'Better value'), valueText, summary.diff > 0 ? tokenText('decisionBetterValueCopy', 'Current displayed price difference: {price_difference}.', { price_difference: money(summary.diff) }) : configText('decisionTieValueCopy', 'Use fit and features to break the tie.')) +
          verdictCard(configText('decisionBestResolutionLabel', 'Best listed resolution'), resolutionText, configText('decisionBestResolutionCopy', 'Only pay for more resolution when identification confidence matters in the field.')) +
          verdictCard(configText('decisionBestLrfLabel', 'Best if you need LRF'), lrfText, configText('decisionBestLrfCopy', 'LRF is worth paying for when distance confirmation changes the shot.')) +
          verdictCard(configText('decisionOverkillLabel', 'Overkill warning'), configText('decisionOverkillTitle', 'Do not overbuy the problem'), configText('decisionOverkillCopy', 'This is overkill if your distances are short, your setup should stay simple, or a lower-cost optic already solves the job.')) +
        '</div>';
    }

    function tableRow(label, leftValue, rightValue) {
      return '<tr><th>' + escapeHtml(label) + '</th><td>' + escapeHtml(display(leftValue)) + '</td><td>' + escapeHtml(display(rightValue)) + '</td></tr>';
    }

    function buildBuyerTable(left, right) {
      var summary = comparisonSummary(left, right);
      var rec = summary.sameFamily && summary.diff > 0 ? tokenText('buyerRecommendationCheaper', '{cheaper_title} is the better value unless {higher_title} gives you a specific field benefit you will use.', { cheaper_title: summary.cheaper.title, higher_title: summary.higher.title }) : configText('buyerRecommendationDefault', 'Pick the product format and use case first. Then let price decide between close matches.');
      var rows = [
        ['Best use case', left.best_for, right.best_for],
        ['Best buyer', left.primary_use_case || left.best_for, right.primary_use_case || right.best_for],
        ['Budget fit', budgetLabel(left), budgetLabel(right)],
        ['Product format', opticFamily(left), opticFamily(right)],
        ['Resolution / image confidence', left.sensor_resolution, right.sensor_resolution],
        ['Hunting distance', distanceLabel(left), distanceLabel(right)],
        ['Terrain fit', left.terrain_fit || 'Match to your field conditions', right.terrain_fit || 'Match to your field conditions'],
        ['Hog hunting', productSearchText(left).indexOf('hog') !== -1 ? 'Strong fit where the format matches your setup' : 'Depends on distance and terrain', productSearchText(right).indexOf('hog') !== -1 ? 'Strong fit where the format matches your setup' : 'Depends on distance and terrain'],
        ['Coyote / predator hunting', productSearchText(left).indexOf('coyote') !== -1 || productSearchText(left).indexOf('predator') !== -1 ? 'Built around predator hunting use cases' : 'Check magnification, range, and ID needs', productSearchText(right).indexOf('coyote') !== -1 || productSearchText(right).indexOf('predator') !== -1 ? 'Built around predator hunting use cases' : 'Check magnification, range, and ID needs'],
        ['Scanning vs shooting', left.handheld || opticFamily(left), right.handheld || opticFamily(right)],
        ['Rangefinder need', hasRangefinder(left) ? 'Built-in LRF listed' : 'No built-in LRF listed', hasRangefinder(right) ? 'Built-in LRF listed' : 'No built-in LRF listed'],
        ['Battery practicality', left.battery_life, right.battery_life],
        ['Weight / handling', left.weight, right.weight],
        ['Overkill risk', left.overkill_if || 'Could be overkill if your distances are short or your setup should stay simple', right.overkill_if || 'Could be overkill if your distances are short or your setup should stay simple'],
        ['Thermal Bros recommendation', rec, rec]
      ];
      return '<h2>' + escapeHtml(configText('buyerTableHeading', 'Real-world comparison')) + '</h2><table class="tb-comparison-table"><thead><tr><th>' + escapeHtml(configText('buyerDecisionPointHeading', 'Decision point')) + '</th><th>' + escapeHtml(left.title) + '</th><th>' + escapeHtml(right.title) + '</th></tr></thead><tbody>' + rows.map(function (row) { return tableRow(row[0], row[1], row[2]); }).join('') + '</tbody></table>';
    }

    function groupRow(label, leftValue, rightValue) {
      return '<div class="tb-spec-group__row"><span>' + escapeHtml(label) + '</span><b>' + escapeHtml(display(leftValue)) + '</b><b>' + escapeHtml(display(rightValue)) + '</b></div>';
    }

    function specGroup(title, note, rows, left, right) {
      return '' +
        '<article class="tb-spec-group">' +
          '<div class="tb-spec-group__header"><h3>' + escapeHtml(title) + '</h3><p>' + escapeHtml(note) + '</p></div>' +
          '<div class="tb-spec-group__head"><span>Spec</span><span>' + escapeHtml(left.title) + '</span><span>' + escapeHtml(right.title) + '</span></div>' +
          rows.map(function (row) { return groupRow(row[0], row[1], row[2]); }).join('') +
        '</article>';
    }

    function buildSpecTable(left, right) {
      var groups = [
        specGroup('Image and detection', 'Use this to understand image confidence, not to crown a fake winner.', [
          ['Sensor resolution', left.sensor_resolution, right.sensor_resolution],
          ['NETD', left.netd, right.netd],
          ['Pixel pitch', left.pixel_pitch, right.pixel_pitch],
          ['Objective lens', left.objective_lens, right.objective_lens],
          ['Base magnification', left.base_magnification, right.base_magnification],
          ['Max magnification', left.max_magnification, right.max_magnification],
          ['Detection range', left.detection_range, right.detection_range],
          ['Refresh rate', left.refresh_rate, right.refresh_rate],
          ['Field of view', left.field_of_view, right.field_of_view],
          ['Display resolution', left.display_resolution, right.display_resolution]
        ], left, right),
        specGroup('Rangefinder decision', 'LRF is useful when distance confirmation changes the shot. It is extra cost when it does not.', [
          ['Rangefinder', left.rangefinder, right.rangefinder],
          ['Rangefinder max range', left.rangefinder_max_range, right.rangefinder_max_range]
        ], left, right),
        specGroup('Handling and power', 'Weight, battery, and form factor matter when the optic is actually in the field.', [
          ['Battery life', left.battery_life, right.battery_life],
          ['Weight', left.weight, right.weight],
          ['Dimensions', left.dimensions, right.dimensions],
          ['Power source', left.power_source, right.power_source]
        ], left, right),
        specGroup('Format and support', 'Start with the right tool type, then compare support and buying confidence.', [
          ['Price', money(left.price), money(right.price)],
          ['Brand', left.brand || left.vendor, right.brand || right.vendor],
          ['Product type', left.product_type, right.product_type],
          ['Clip-on', left.clip_on || (isClipOn(left) ? 'Yes' : 'No'), right.clip_on || (isClipOn(right) ? 'Yes' : 'No')],
          ['Handheld', left.handheld, right.handheld],
          ['Warranty / support note', left.support_note || left.why_buy_from_thermal_bros, right.support_note || right.why_buy_from_thermal_bros]
        ], left, right)
      ];
      return '<h2>' + escapeHtml(configText('specTableHeading', 'Grouped specs')) + '</h2><div class="tb-spec-groups">' + groups.join('') + '</div>';
    }

    function buildFieldGuide(left, right) {
      var summary = comparisonSummary(left, right);
      var valueSentence = summary.diff > 0 ? tokenText('fieldValueSentence', 'When both options solve the same shot, the lower price on {cheaper_title} should matter.', { cheaper_title: summary.cheaper.title }) : configText('fieldTieSentence', 'With similar pricing, use field fit to decide.');
      var cards = builderConfig.fieldCards && builderConfig.fieldCards.length ? builderConfig.fieldCards : [];
      cards = cards.filter(function (card) { return card && (card.title || card.copy); });
      if (!cards.length) {
        cards = [
          { title: 'Inside 100 yards', copy: 'Simplicity, field of view, and fast confirmation usually matter more than buying the highest sensor on the page.' },
          { title: '100-200 yards', copy: 'Image confidence and comfortable base magnification start to matter, but {value_sentence}' },
          { title: '200-300 yards', copy: 'Resolution, useful magnification, and range awareness become easier to justify when identification is the real problem.' },
          { title: '300+ yards', copy: 'Premium image detail and range confidence can matter more in open fields, but they still need to match your actual shot opportunities.' }
        ];
      }
      return '' +
        '<h2>' + escapeHtml(configText('fieldGuideHeading', 'What changes in the field?')) + '</h2>' +
        '<div class="tb-field-grid">' +
          cards.map(function (card) {
            var copy = toText(card.copy).replace(/\{value_sentence\}/g, valueSentence);
            return '<article><h3>' + escapeHtml(card.title) + '</h3><p>' + escapeHtml(copy) + '</p></article>';
          }).join('') +
        '</div>';
    }

    function updateHash() {
      var params = new URLSearchParams();
      var filters = getFilters();
      if (leftSelect.value) params.set('left', leftSelect.value);
      if (rightSelect.value) params.set('right', rightSelect.value);
      Object.keys(filters).forEach(function (key) {
        if (filters[key]) params.set(key, filters[key]);
      });
      var hash = params.toString();
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', window.location.pathname + (hash ? '#' + hash : ''));
      }
    }

    function applyStateFromUrl() {
      var values = {};
      var rawHash = window.location.hash ? window.location.hash.replace(/^#/, '') : '';
      var params = new URLSearchParams(rawHash);
      var queryParams = new URLSearchParams(window.location.search || '');
      ['left', 'right', 'product_type', 'brand', 'budget', 'resolution', 'rangefinder', 'clip_on', 'use_case', 'distance', 'terrain'].forEach(function (key) {
        if (params.has(key)) values[key] = params.get(key);
        else if (queryParams.has(key)) values[key] = queryParams.get(key);
      });

      if (queryParams.has('left') || queryParams.has('right')) {
        var robots = document.querySelector('meta[name="robots"]');
        if (!robots) {
          robots = document.createElement('meta');
          robots.setAttribute('name', 'robots');
          document.head.appendChild(robots);
        }
        robots.setAttribute('content', 'noindex,follow');
      }

      setFilters(values);
      if (values.left) leftSelect.setAttribute('data-pending-value', values.left);
      if (values.right) rightSelect.setAttribute('data-pending-value', values.right);
    }

    function applyPendingSelects(list) {
      var pendingLeft = leftSelect.getAttribute('data-pending-value');
      var pendingRight = rightSelect.getAttribute('data-pending-value');
      if (pendingLeft && list.some(function (product) { return product.handle === pendingLeft; })) leftSelect.value = pendingLeft;
      if (pendingRight && list.some(function (product) { return product.handle === pendingRight; })) rightSelect.value = pendingRight;
      leftSelect.removeAttribute('data-pending-value');
      rightSelect.removeAttribute('data-pending-value');
    }

    function render() {
      var list = filteredProducts();
      populateProductSelects(list);
      applyPendingSelects(list);

      var left = getProduct(leftSelect.value);
      var right = getProduct(rightSelect.value);

      if (countNode) countNode.textContent = tokenText('productCountTemplate', '{count} eligible new retail products match the current filters.', { count: list.length });
      if (emptyNode) emptyNode.hidden = list.length > 0;
      if (resultsNode) resultsNode.hidden = !left || !right;

      if (!left || !right) return;

      if (cardsNode) cardsNode.innerHTML = productCard(left, configText('productALabel', 'Product A')) + '<div class="tb-vs-divider" aria-hidden="true"><span>' + escapeHtml(configText('vsLabel', 'VS')) + '</span></div>' + productCard(right, configText('productBLabel', 'Product B'));
      if (recommendationNode) recommendationNode.innerHTML = buildRecommendation(left, right);
      if (decisionCardsNode) decisionCardsNode.innerHTML = buildDecisionCards(left, right);
      if (visualComparisonNode) visualComparisonNode.innerHTML = buildVisualComparison(left, right);
      if (buyerTableNode) buyerTableNode.innerHTML = buildBuyerTable(left, right);
      if (specTableNode) specTableNode.innerHTML = buildSpecTable(left, right);
      if (fieldGuideNode) fieldGuideNode.innerHTML = buildFieldGuide(left, right);
      updateHash();
    }

    populateStaticFilterOptions();
    applyStateFromUrl();
    render();

    filterNodes.forEach(function (node) {
      node.addEventListener('change', render);
    });

    leftSelect.addEventListener('change', render);
    rightSelect.addEventListener('change', render);

    if (swapButton) {
      swapButton.addEventListener('click', function () {
        var leftValue = leftSelect.value;
        leftSelect.value = rightSelect.value;
        rightSelect.value = leftValue;
        render();
      });
    }

    if (copyButton) {
      copyButton.addEventListener('click', function () {
        updateHash();
        var url = window.location.origin + window.location.pathname + window.location.hash;
        var done = function () {
          copyButton.textContent = configText('shareCopied', 'Share link copied');
          window.setTimeout(function () { copyButton.textContent = configText('shareReset', 'Copy share link'); }, 2200);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(done);
        } else {
          var input = document.createElement('input');
          input.value = url;
          document.body.appendChild(input);
          input.select();
          try { document.execCommand('copy'); } catch (error) {}
          document.body.removeChild(input);
          done();
        }
      });
    }
  };

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) {
      initAll(event.target);
    }
  });

  document.addEventListener('shopify:section:select', function (event) {
    if (event && event.target) {
      initAll(event.target);
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    if (event && event.target) {
      var section = event.target.closest('[data-section-type]');
      initAll(section || document);
    }
  });

  initAll(document);

  if (typeof MutationObserver !== 'undefined') {
    var emptyHashLinkObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        for (var i = 0; i < mutation.addedNodes.length; i++) {
          var node = mutation.addedNodes[i];
          if (node && node.nodeType === 1) labelEmptyHashLinks(node);
        }
      });
    });

    emptyHashLinkObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
